import type { PresentTypeBasedComponentsProps } from './presentTypeComponentType'

/**
 * PresentType 軸の/rewards/detail ページで使用されるコンポーネント
 * このパターンは存在しないのでnullを返す。
 * ただ、あったことを明示するために残しておく。
 * */
export const PresentType03EntryComponents = ({}: PresentTypeBasedComponentsProps) => {
  return null
}
